import { Component, Input } from '@angular/core';

export interface SetupGuideStep {
  /** Step marker. A number for ordered steps; omit for a "turning it off" style step. */
  num?: number | string;
  title: string;
  /** Body copy. Supports inline markup (e.g. <strong>) and is rendered as trusted template HTML. */
  body: string;
  /** Renders the marker in the muted red "off" treatment. */
  alt?: boolean;
  /** Expanded on load. Conventionally only the first step. */
  open?: boolean;
}

/**
 * Sticky, collapsible setup guide shown alongside integration settings forms.
 *
 * Extracted from the PayBright / Square / QuickBooks integration pages, which
 * each carried an identical copy of this markup and stylesheet.
 *
 * Inside <app-configuration-page> the guide pins below the sticky page header
 * via the --config-header-offset variable that layout publishes.
 */
@Component({
  selector: 'app-setup-guide',
  templateUrl: './setup-guide.component.html',
  styleUrls: ['./setup-guide.component.css'],
})
export class SetupGuideComponent {
  /** Small uppercase label above the heading. */
  @Input() eyebrow = 'Setup Guide';

  /** Guide heading, e.g. "Connecting your account". */
  @Input() heading = '';

  @Input() steps: SetupGuideStep[] = [];

  /** Optional closing note under the last step. */
  @Input() footer?: string;
}
